/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deceased_MarkInputs */



/**
* | output |
* | --- |
* | "Mark as deceased" |
*
* @param {Deceased_MarkInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deceased_mark = /** @type {((inputs?: Deceased_MarkInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deceased_MarkInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Marquer comme décédé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marcar como fallecido")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Marcar como falecido")
	if (locale === "it") return /** @type {LocalizedString} */ ("Segna come deceduto")
	return /** @type {LocalizedString} */ ("Mark as deceased")
});